var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteIcon = function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.298 10.198c.496 0 .9.405.9.9v5.399c0 .495-.404.9-.9.9a.902.902 0 0 1-.9-.9v-5.395c0-.5.405-.904.9-.904ZM14.802 11.102c0-.495-.405-.9-.9-.9s-.9.405-.9.9v5.4c0 .495.405.899.9.899s.9-.404.9-.9v-5.399Z",
    fill: "#73777A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.026 3.527c.336-.34.795-.527 1.272-.527h3.6a1.802 1.802 0 0 1 1.8 1.8v1.8h3.598c.495 0 .9.404.9.899s-.405.9-.9.9h-.059l-.722 10.092A2.704 2.704 0 0 1 15.82 21H8.376a2.704 2.704 0 0 1-2.695-2.509L4.963 8.4h-.059a.9.9 0 1 1-.004-1.8h3.599V4.8c0-.477.186-.936.527-1.272ZM6.767 8.4l.714 9.965a.903.903 0 0 0 .9.837h7.443a.903.903 0 0 0 .9-.837l.713-9.965H6.768Zm7.135-3.6v1.8h-3.599V4.8h3.599Z",
    fill: "#73777A"
  })));
};
export default SvgDeleteIcon;